import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import MoreVertOutlinedIcon from "@mui/icons-material/MoreVertOutlined";
import Button from "@mui/material/Button";
import * as React from "react";
import {useEffect, useState} from "react";
import Typography from "@mui/material/Typography";
import Popover from "@mui/material/Popover";
import {buttonStyles, typographyStyles} from "../TableTemplate";
import keycloak from "../../../Keycloak";
import {deleteCandidateDocuments} from "../../../utilities/HrAPI";
import ConfirmDeleteDocumentModal from "../../Documents/ConfirmDeleteDocumentModal";
import {showSaveSuccessMessage} from "../../toastUtils";

export default function DocumentsTable({ data, columns, onViewDocument }) {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [showModal, setShowModal] = useState(false);
    const [tableData, setTableData] = useState(data);
    const [documentId, setDocumentId] = useState(0);

    const tableHeaderStyle = {
        backgroundColor: '#DDDFDF',
        height: '56px'
    };

    const handleOptionsClick = (e, id) => {
        setAnchorEl(e.currentTarget);
        setDocumentId(id);
    };

    const handleDelete = (id) => {
        deleteCandidateDocuments(id, keycloak.token)
            .then(() => {
                closeModal();
                showSaveSuccessMessage("Document deleted");
            });
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const closeModal = () => {
        setShowModal(false);
    };

    const openModal = () => {
        handleClose();
        setShowModal(true);
    };

    useEffect(() => {
        setTableData(data);
    }, [data]);

    return (
        <div data-testid={"table-div"}>
            <ConfirmDeleteDocumentModal
                showModal={showModal}
                closeModal={closeModal}
                handleDeleteConfirmation={() => handleDelete(documentId)}
            />
            <TableContainer className="mt-4" component={Paper} sx={{ borderRadius: "4px", boxShadow: "0px 0px 0px 1px #E0E0E0" }}>
                <Table>
                    <TableHead>
                        <TableRow style={tableHeaderStyle}>
                            {columns.map((columnData) => (
                                <TableCell key={columnData.id} sx={{ fontWeight: '600' }}>
                                    {columnData.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {tableData.map((row, index) => (
                            <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell scope="row">{row.dateModified}</TableCell>
                                <TableCell scope="row">{row.type}</TableCell>
                                <TableCell scope="row">{row.name}</TableCell>
                                <TableCell scope="row">{row.fileSize}</TableCell>
                                <TableCell scope="row">
                                    <Button data-testid={`options${index}`}
                                            align="left" variant="text"
                                            style={{ color: 'black' }}
                                            onClick={(event) => handleOptionsClick(event, row.id)}
                                    >
                                        <MoreVertOutlinedIcon/>
                                    </Button>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Popover data-testid={'popover'} open={open} anchorEl={anchorEl} onClose={handleClose}
                     anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} elevation={1}>
                <Typography sx={typographyStyles}>
                    <Button sx={buttonStyles} onClick={() => onViewDocument(documentId)}>View</Button>
                </Typography>
                <Typography sx={typographyStyles}>
                    <Button sx={buttonStyles} data-testid={"deleteDocument"} onClick={openModal}>Delete</Button>
                </Typography>
            </Popover>
        </div>
    );
}